export type ExcoActions =
  | Exco_CTA
  | Exco_SDK
  | Exco_Experience
  | Exco_Placement
  | Exco_Item;

export enum Exco_CTA {
  LOADED = 'pb.cta.loaded',
  CLICKED = 'pb.cta.clicked',
}

export enum Exco_SDK {
  RENDER = 'sdk_render',
}

export enum Exco_Experience {
  LOAD = 'experience_load',
  HIDE = 'experience_hide',
}

export enum Exco_Placement {
  LOAD = 'placement_load',
  TRIGGER = 'trigger_action',
  TRIGGER_OPEN = 'trigger_open',
  TRIGGER_CLOSE = 'trigger_close',
  TRIGGER_HIDE = 'trigger_hide',
}

export enum Exco_Item {
  LOAD = 'pb.item.load',
  IDLE = 'pb.item.idle',
  RENDER = 'pb.item.render',
  PROGRESS = 'pb.item.progress',
  SHARE = 'pb.item.share',
  CHANGE = 'pb.item.change',
  SCROLL_TOP_INTO_VIEW = 'pb.item.scroll-top-into-view',
  SCROLL_TOP_OUT_OF_VIEW = 'pb.item.scroll-top-out-of-view',
  SCROLL_BOTTOM_INTO_VIEW = 'pb.item.scroll-bottom-into-view',
  SCROLL_BOTTOM_OUT_OF_VIEW = 'pb.item.scroll-bottom-out-of-view',
  POWERED_BY_LINK = 'pb.item.powered-by-link',
  PLACEMENT_COMPLETED = 'pb.placement-unit.completed',
  PLACEMENT_HEIGHT = 'pb.placement-unit.height',
}
